import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
  forwardRef,
} from '@chakra-ui/react';
import React from 'react';

import { ChevronLeftIcon, ChevronRightIcon } from '../Icons';
import { default as WLLink } from '../Link';

export interface ButtonProps extends ChakraButtonProps {
  type?: 'submit' | 'reset' | 'button';
  uppercase?: boolean;
  capitalize?: boolean;
  variant?:
    | 'solid'
    | 'outline'
    | 'primary'
    | 'primaryReverse'
    | 'primaryMicro'
    | 'secondaryWhite'
    | 'secondaryBlue';
  href?: string;
  colorScheme?:
    | 'red'
    | 'blue'
    | 'white'
    | 'lightblue'
    | 'wl-blue'
    | 'wl-white'
    | 'wl-blue-secondary'; // THW -added wl-blue to pass new colorScheme until we have finalized button styles on entire site
  directionalIcon?: 'back' | 'forward';
  onClick?: ChakraButtonProps['onClick'];
}

type WLLinkProps = React.ComponentProps<typeof WLLink>;

const PlainWLLink = forwardRef<WLLinkProps, 'a'>(
  ({ children, ...props }, ref) => (
    <WLLink {...props} ref={ref} variant="plain">
      {children}
    </WLLink>
  ),
);

const Button: React.FC<ButtonProps> = ({
  type = 'button',
  uppercase = false,
  capitalize = false,
  variant = 'solid',
  colorScheme = 'button',
  href,
  directionalIcon,
  children,
  ...rest
}) => {
  if (href) {
    return (
      <ChakraButton
        as={PlainWLLink}
        to={href}
        textTransform={
          uppercase ? 'uppercase' : capitalize ? 'capitalize' : undefined
        }
        variant={variant}
        colorScheme={colorScheme}
        flexDirection="row"
        {...rest}
      >
        {directionalIcon === 'back' && <ChevronLeftIcon />}
        {children}
        {directionalIcon === 'forward' && <ChevronRightIcon />}
      </ChakraButton>
    );
  }
  return (
    <ChakraButton
      textTransform={uppercase ? 'uppercase' : undefined}
      colorScheme={colorScheme}
      variant={variant}
      type={type}
      {...rest}
    >
      {directionalIcon === 'back' && <ChevronLeftIcon />}
      {children}
      {directionalIcon === 'forward' && <ChevronRightIcon />}
    </ChakraButton>
  );
};

export default Button;
